export default "__VITE_ASSET__DtwkqgKw__"